// extracted by mini-css-extract-plugin
export default {"statistics_container":"Statistics_statistics_container__9wLkT"};